import React, { useState, useEffect } from 'react';
import { useAuth } from '../AuthContext';

function RoleSwitchModal({ isOpen, onClose }) {
  const { roles, selectedRole, switchRole } = useAuth();
  const [tempSelectedRole, setTempSelectedRole] = useState(selectedRole);

  // Sync tempSelectedRole when modal opens or selectedRole changes
  useEffect(() => {
    if (isOpen) {
      setTempSelectedRole(selectedRole);
    }
  }, [isOpen, selectedRole]);

  if (!isOpen) {
    return null;
  }

  // Format role name for display
  const formatRoleName = (role) => {
    return role
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const handleConfirm = () => {
    if (tempSelectedRole && tempSelectedRole !== selectedRole) {
      // Only switch if a different role is selected
      switchRole(tempSelectedRole);
      // switchRole will handle closing and reloading
    } else {
      // Same role selected, just close
      onClose();
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Switch Role</h2>
          <button
            className="modal-close-btn"
            onClick={onClose}
            aria-label="Close modal"
          >
            ✕
          </button>
        </div>

        <div className="modal-body">
          <p className="modal-description">Select a role to switch to:</p>
          
          <div className="role-list">
            {roles && roles.length > 0 ? (
              roles.map(role => (
                <div key={role} className="role-option">
                  <input
                    type="radio"
                    id={`role-${role}`}
                    name="role"
                    value={role}
                    checked={tempSelectedRole === role}
                    onChange={e => setTempSelectedRole(e.target.value)}
                  />
                  <label htmlFor={`role-${role}`} className="role-label">
                    <span className="role-name">{formatRoleName(role)}</span>
                    {selectedRole === role && (
                      <span className="role-badge">Current</span>
                    )}
                  </label>
                </div>
              ))
            ) : (
              <p className="no-roles">No roles available</p>
            )}
          </div>
        </div>

        <div className="modal-footer">
          <button
            className="btn btn-secondary"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleConfirm}
            disabled={!tempSelectedRole || (tempSelectedRole === selectedRole)}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}

export default RoleSwitchModal;
